module.exports = __webpack_public_path__ + "newsletter/Components/PocketHitsSignup/images/publishers/logo-quartz.b647cb6b1cce5cfa2e766e524a2157cb.png";